import { createSlice } from "@reduxjs/toolkit";
import predictHemorrhageApi from "@custom/rtk-apis/aiServices/predictHemorrhage";

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const predictHemorrhageSlice = createSlice({
  name: "predictHemorrhageSlice",
  initialState,
  reducers: {revertStatus:(state) => {
      // Reset all state properties to their initial values
      state.status = initialState.status;
      state.result = initialState.result;
      state.msg = initialState.msg;
      state.loading = initialState.loading;
      state.error = initialState.error;
    }},
  extraReducers: (builder) => {
    console.log("----------", builder)
    builder
      .addCase(predictHemorrhageApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
         state.error = "";
      })
      .addCase(predictHemorrhageApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload)
        state.loading = false;
        state.status = "success";
        state.result = payload.summary;
        state.msg = payload.msg;
        state.error = "";
      })
      .addCase(predictHemorrhageApi.rejected, (state, { payload }) => {
        console.log("Rejected",payload)
       state.loading = false;
        state.status = "error";
        state.error = payload as string;
      });
  },
});

export default predictHemorrhageSlice.reducer;
export const { revertStatus } = predictHemorrhageSlice.actions;
